<script setup>
import { onMounted } from 'vue';
import { useStore } from 'dashboard/composables/store';

const store = useStore();

onMounted(() => {
 store.dispatch('forms/get');
});
</script>

<template>
 <div class="flex h-full w-full">
 <router-view />
 </div>
</template>
